import moment from 'moment';
import { defineMessages, IntlShape } from 'react-intl';

const messages = defineMessages({
  completedBy: {
    id: 'components.surveyForm.completedBy',
    defaultMessage: `Completed by {name}`,
  },
  submittedOn: {
    id: 'components.surveyForm.submittedOn',
    defaultMessage: `Submitted on {timestamp}`,
  },
});

const getFormMeta = (
  intl: IntlShape,
  authoredDate: Date | undefined | null,
  patient?: fhir.Patient,
) => {
  const formattedDate = authoredDate
    ? moment(authoredDate).format('MM/DD/YY hh:mm:ss A')
    : undefined;

  const submittedOnMessage = formattedDate
    ? intl.formatMessage(messages.submittedOn, {
        timestamp: formattedDate,
      })
    : '';

  const firstName = patient?.name?.[0].given;
  const lastName = patient?.name?.[0].family;
  const completedByMessage =
    firstName && lastName
      ? intl.formatMessage(messages.completedBy, {
          name: `${firstName} ${lastName}`,
        })
      : '';

  return { submittedOnMessage, completedByMessage };
};

export default getFormMeta;
